'use client'

import { format } from 'date-fns'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import React from 'react'

import ZHeroCompactLeftCard from '@/_components/sections/hero-compact/z-hero-compact-left-card'
import { handleProgramaticScroll } from '@/_lib/utils'
import { IJob } from '@/_types/jobs'

interface IProps {
	job: IJob
}

function JobDescriptionList({ children }: { children: React.ReactNode }) {
	return <div className='flex flex-col gap-2 mt-8 pb-6'>{children}</div>
}

function JobDescriptionItem({ label, value }: { label: string; value: string }) {
	return (
		<div className='flex justify-between align-top border-b border-c10 pb-2 last:border-b-0'>
			<p className='font-medium!'>{label}</p>
			<p className='font-medium!'>{value}</p>
		</div>
	)
}

export default function AJobHero({ job }: IProps) {
	const t = useTranslations('pages.jobs.detail.hero')

	return (
		<div className='bg-c4'>
			<div className='box_detail-amb wrapper2 pdb-90lg pdb-70 pos_rel pt-[200px]!'>
				<div className='box_detail-amb_inner box_detail-amb_inner--full'>
					<ZHeroCompactLeftCard
						title={job.title}
						text={job.contractType}
						textChildren={
							<JobDescriptionList>
								<JobDescriptionItem label={t('list.pay')} value={job.pay} />
								{job.startDate && (
									<JobDescriptionItem
										label={t('list.startDate')}
										value={format(new Date(job.startDate), 'dd.MM.yyyy')}
									/>
								)}
							</JobDescriptionList>
						}
						buttonText={job.externalLink ? t('openProfesia') : undefined}
						buttonLink={job.externalLink || undefined}
						buttonIconDesktop={job.externalLink ? 's_ar2_ru' : undefined}
						buttonIconMobile={job.externalLink ? 's_ar2_ru' : undefined}
					/>
					<div className='box_detail-amb_right mgt-40lg min-h-[400px] relative w-full bg-[#8DBDFF]!'>
						<h2 className='text-white text-2xl font-medium'>{t('contact.title')}</h2>

						<p className='text-white text-base font-light'>
							{t('contact.description')}{' '}
						</p>

						<Link
							href='#napiste-nam'
							className={'btn_basic type2 mgt-40 mgt-20sm'}
							prefetch={false}
							onClick={handleProgramaticScroll}
						>
							<span>{t('contact.button')}</span>
							<span>
								<span>
									<svg className='sico'>
										<use href={`/assets/layout/icons.svg#${'s_ar2_r'}`} />
									</svg>
								</span>
								<span>
									<svg className='sico'>
										<use href={`/assets/layout/icons.svg#${'s_ar2_r'}`} />
									</svg>
								</span>
							</span>
						</Link>
						<img
							src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/illustrations/small-wave/small-medante-wave-blue-02.svg`}
							alt='Ilustračná vlnka'
							className='h-36 -mb-1'
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
